// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__pyZxA","text":"Footer_text__SW8wL"};